import { useState } from "react";
import { MenuItem } from "@mui/material";

import KogModalSideComponent from "@/main/components/modal/ModalSide";
import { canCorrectCartPrice } from "@/main/components/shared/boxCart/components/utilsCorrectPrice";
import ModalCorrectCartPrice from "@/main/components/shared/boxCart/components/modalCorrectCartPrice/modalCorrectCartPrice";
import { ClaimGridItemPartResponse } from "@/main/models/response";
import { RoutesConstants } from "@/main/routes/routesConstants";
import { Controls } from "@/main/services/constants/constantsControl";
import {
	getGuidScreenByRoute,
	getTranslateByKey,
	isNullUndefinedEmpty,
	isShowControlByElementId,
} from "@/main/services/utils";
import { userIsSupplier } from "@/main/services/utilsUser";

import { useThreeDotsPartClaimContext } from "../context";
import OptionEmptySearchClaim from "../optionEmptySearchClaim";

interface IOptionCorrectPricePartSearchClaimProps {
	part: ClaimGridItemPartResponse;
	refreshClaim: () => void;
}
function OptionCorrectPricePartSearchClaim({ part, refreshClaim }: IOptionCorrectPricePartSearchClaimProps) {
	const { generateIdMenu, closeThreeDotsPartClaim } = useThreeDotsPartClaimContext();
	const [isOpen, setIsOpen] = useState<boolean>(false);

	const showCorrectPriceOption =
		!isNullUndefinedEmpty(part.guidQuoteSupplierItem) &&
		canCorrectCartPrice({
			idProcurementStatus: part.idProcurementStatus,
			isUserSupplier: userIsSupplier(),
			showPrices: isShowControlByElementId(Controls.IdShowPrices),
			hasCorrectPriceControl: isShowControlByElementId(Controls.IdCorrectPriceAwaitingRelease),
		});

	function handleCorrectPrice() {
		setIsOpen(true);
		closeThreeDotsPartClaim();
	}

	function handleCorrected() {
		refreshClaim();
	}

	if (!showCorrectPriceOption) return <OptionEmptySearchClaim option="OptionCorrectPrice" />;
	return (
		<>
			<MenuItem id={generateIdMenu("correct-price")} onClick={handleCorrectPrice}>
				{getTranslateByKey("information.correctPrice")}
			</MenuItem>
			<KogModalSideComponent
				open={isOpen}
				title={getTranslateByKey("information.editPart")}
				titleModalReducer="ModalPartEdit"
				closeModal={() => setIsOpen(false)}
			>
				{isOpen && (
					<ModalCorrectCartPrice
						part={{
							guidQuoteSupplierItem: String(part.guidQuoteSupplierItem),
							price: part.price,
							quoteProcurementPartInfo: part.quoteProcurementPartInfo,
						}}
						supplierName={part.supplierName}
						guidScreen={getGuidScreenByRoute(RoutesConstants.claimSearchClaims)}
						onCorrected={handleCorrected}
						closeModal={() => setIsOpen(false)}
					/>
				)}
			</KogModalSideComponent>
		</>
	);
}

export default OptionCorrectPricePartSearchClaim;
